"use client"

import styled from "@emotion/styled"
import { BlockRenderer } from "ui"
import BottomTextAndImage from "../Careers/BottomTextAndImage"
import TopContent from "./TopContent"
import { useLayoutEffect } from "react"

type Props = {
  data: any
  job: any
  messages?: any
}

const StyledPageContainer = styled("div")`
  position: relative;
  overflow-x: hidden;
  ${(p) => p.theme.breakpoints.up("md")} {
    &::before {
      content: "";
      position: absolute;
      top: 490px;
      right: -300px;
      background-image: url("/career-frame.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0.2;
      z-index: -1;
      width: 900px;
      height: 600px;
    }
  }
`

const components = {
  bottomTextAndImage: BottomTextAndImage,
}

function Career({ data, job, messages }: Props) {
  useLayoutEffect(() => {
    if (typeof window !== "undefined") {
      // Disable browser scroll restoration
      if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual"
      }
      // Force scroll to top after layout calculation
      requestAnimationFrame(() => {
        window.scrollTo(0, 0)
      })
    }
  }, [])

  const hasBanner = data?.page?.properties?.some(
    (block: any) => block.blockType === "topBanner" || block.blockType === "HeaderWithHeroAndText",
  )
  const innerJobData = data?.page?.children?.find((child: any) => child.name === "inner job page")

  return (
    <StyledPageContainer>
      <TopContent job={job} messages={messages} data={data} />
      {innerJobData?.properties?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "contentText") {
          additionalProps = {
            hasBanner,
          }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.propertyName}
            blockData={block}
            components={components}
            props={additionalProps}
          ></BlockRenderer>
        )
      })}
    </StyledPageContainer>
  )
}

export default Career
